import { 
  intersection, 
  cloneDeep, 
  findIndex, 
  isEmpty, 
  sumBy,
} from 'lodash'
import {
  ROLES,
  PLAID_STATUS,
  DONDE,
  USER_ACCOUNT_STATUS,
  DATE_FORMAT,
  TIME_FORMAT,
  FREQUENCY_TYPES,
  WEEKLY_FREQUENCY_VALUES,
  MONTHLY_FREQUENCY_VALUES,
} from 'utils/constants'
import breakpoints, { windowWidth, currentBP } from 'theme/breakpoints'
import PropTypes from 'prop-types'
import moment from 'moment/moment'

export const hasRole = (arr1 = [], arr2 = []) => !!intersection(arr1, arr2).length
// export const isCustomerAdmin = (arr1 = []) => arr1.includes(ROLES.CUSTOMER_ADMIN)
// export const isAdmin = (arr1 = []) => isCustomerAdmin(arr1)

export const canUseAccount = account => {
  const status = account?.error_status || account?.verification_status || ''
  return (
    !!account &&
    ![
      PLAID_STATUS.PENDING_AUTOMATIC_VERIFICATION,
      PLAID_STATUS.PENDING_MANUAL_VERIFICATION,
      PLAID_STATUS.VERIFICATION_EXPIRED,
      PLAID_STATUS.VERIFICATION_FAILED,
      PLAID_STATUS.ITEM_LOGIN_REQUIRED,
    ].includes(status)
  )
}

export const getUserStatus = user => {
  if (user.savings_account_status === 2 && user.is_active === true)
    return USER_ACCOUNT_STATUS.ACTIVE
  if (user.savings_account_status !== 2 && user.is_active === true)
    return USER_ACCOUNT_STATUS.INACTIVE
  if (user.is_active === false) return USER_ACCOUNT_STATUS.DEACTIVATED
}

export const replace = (data, search, newData) => {
  const index =
    typeof search === 'number'
      ? search
      : typeof data?.[0] === 'object'
      ? findIndex(data, search)
      : data?.indexOf?.(search)
  const temp = cloneDeep(data)
  newData
    ? temp.splice(index, 1, { ...data[index], ...newData })
    : temp.splice(index, 1)
  return temp
}

export const scrollTo = (id, scrollEl) => {
  const el = scrollEl || window
  el.scrollTo({
    behavior: 'smooth',
    top: document.getElementById(id)?.offsetTop,
  })
}

export const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop)
    window.scrollTo(0, c - c / 8)
  }
}

export const jumpToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop
  if (c > 0) window.scroll(0, 0)
}

export const getParam = variable => {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1])
    }
  }
}

export const htmlEncode = str =>
  String(str).replace(/[^\w. ]/gi, c => `&#${c.charCodeAt(0)};`)

export const htmlDecode = str => {
  const txt = document.createElement('textarea')
  txt.innerHTML = str
  return txt.value
}

export const jsEscape = str =>
  String(str).replace(
    /[^\w. ]/gi,
    c => `\\u${`0000${c.charCodeAt(0).toString(16)}`.slice(-4)}`
  )

export const removeTags = (str = '') =>
  str === null || str === '' ? '' : str.toString().replace(/(<([^>]+)>)/gi, '')

export const printIt = () => {
  try {
    document.execCommand('print', false, null)
  } catch (e) {
    window.print()
  }
}

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
)
export const isFirefox = navigator.userAgent.indexOf('Firefox') > -1
export const isCrappyBrowser = isSafari || isFirefox

export const parseDate = data => {
  if (isSafari || isFirefox) {
    const newData = data.split('-')
    return `${newData[2]}/${newData[0]}/${newData[1]}`
  }
  return data
}

export const scaleImage = imageUrl => {
  let windowWidth = window.innerWidth
  let maxWidth = windowWidth > 1000 ? 1000 : windowWidth
  let scaledImageUrl = imageUrl.replace("upload/", `upload/w_${maxWidth},`)
  return scaledImageUrl
}

export const setImage = (name, { noScale, cropOptions } = {}) => {
  const isSVG = name?.includes('.svg')
  const resize = `w_${
    windowWidth < breakpoints.md && !noScale ? '0.5' : '1.0'
  },${isSVG ? '' : 'f_auto,'}c_scale/`
  let crop = ''
  if (cropOptions?.[currentBP]) {
    crop = `w_${
      cropOptions?.[currentBP].w === 'dynamic'
        ? windowWidth
        : cropOptions?.[currentBP].w
    },h_${cropOptions[currentBP].h},c_crop/`
  }
  return `https://res.cloudinary.com/donde/image/upload/${resize}${crop}v1616000654/app_assets/${name}`
}

export const resizeCloudinaryImage = (url = '', size = '1.0') => 
   url.replace('upload/', `upload/w_${size},c_scale/`)
  // let crop = ''
  // if (cropOptions?.[currentBP]) {
  //   crop = `w_${
  //     cropOptions?.[currentBP].w === 'dynamic'
  //       ? windowWidth
  //       : cropOptions?.[currentBP].w
  //   },h_${cropOptions[currentBP].h},c_crop/`
  // }
  // return `https://res.cloudinary.com/donde/image/upload/${resize}${crop}v1616000654/app_assets/${name}`


export const openSupportEmail = () => window.open(DONDE.LINKS.SUPPORT, '_blank')
// export const openSupportEmail = subject => window.open(DONDE.LINKS.SUPPORT + typeof subject === 'string' ? `?subject=${subject}` : '', '_blank')

export const openBookingEmail = () =>
  window.open(DONDE.LINKS.BOOKING_EMPTY, '_blank')

export const returnIfEmpty = (val, returnVal = '') => {
  if (typeof val === 'string') return val.length ? val : returnVal
  if (typeof val === 'object') return !isEmpty(val) ? val : returnVal
  if (typeof val === 'array') return !isEmpty(val) ? val : returnVal
}

export const getImageLightness = (imageSrc, callback) => {
  const img = document.createElement('img')
  img.src = imageSrc
  img.style.display = 'none'
  document.body.appendChild(img)

  let colorSum = 0

  img.onload = function() {
    const canvas = document.createElement('canvas')
    canvas.width = this.width
    canvas.height = this.height

    const ctx = canvas.getContext('2d')
    ctx.drawImage(this, 0, 0)

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
    const { data } = imageData
    let r
    let g
    let b
    let avg

    for (let x = 0, len = data.length; x < len; x += 4) {
      r = data[x]
      g = data[x + 1]
      b = data[x + 2]

      avg = Math.floor((r + g + b) / 3)
      colorSum += avg
    }

    const brightness = Math.floor(colorSum / (this.width * this.height))
    callback(brightness)
  }
}

export const castCurrencyToString = val => {
  const n = +val || 0
  return n.toString()
}

export const formatDate = (date, format) =>
  new Date(date).toLocaleDateString('en-US', typeof format === 'string' ? DATE_FORMAT[format] : format)

export const formatTime = (date, format) =>
  new Date(date).toLocaleTimeString('en-US', TIME_FORMAT[format])

export const getScrollPosition = el => {
  const { offsetWidth = 0, scrollLeft = 0, scrollWidth = 0 } = el || {}

  return offsetWidth >= scrollWidth
    ? ''
    : scrollLeft === 0
    ? 'left'
    : offsetWidth + scrollLeft >= scrollWidth
    ? 'right'
    : 'center'
}

export const getDaysBetweenDates = (dateOne, dateTwo) => {
  const tempDateOne = new Date(dateOne)
  const tempDateTwo = new Date(dateTwo)
  const differenceInTime = tempDateTwo.getTime() - tempDateOne.getTime()
  return Math.floor(differenceInTime / (1000 * 3600 * 24))
}

export const getLastDayOfCurrentMonth = (dateOne, dateTwo) => {
  const now = new Date()
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
  return lastDay
}

export const formatPhoneNumber = phoneNumber => {
  var cleaned = (`${  phoneNumber}`).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    var intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return null
}

export const saveSearch = (data, type) => {
  // md5()
  let savedHistory = window.localStorage?.getItem('search_history')
  savedHistory = savedHistory ? JSON.parse(savedHistory) : []
  savedHistory?.unshift?.({ ...data, type })
  window.localStorage?.setItem('search_history', JSON.stringify(savedHistory))
}

export const getSavedSearches = () => JSON.parse(window.localStorage?.getItem('search_history')) || []

export const getNextContributionDate = ({
  frequency_type,
  frequency_value,
}) => {
  const frequencyValue = frequency_type === 2 ? WEEKLY_FREQUENCY_VALUES[frequency_value]?.moment_value : MONTHLY_FREQUENCY_VALUES[frequency_value]?.moment_value
  const d = moment()

  if (frequency_type === 2) {
    const currentWeekday = moment().isoWeekday()
    if (currentWeekday <= frequencyValue) { 
      d.isoWeekday(frequencyValue)
    } else {
      d.add(1, 'weeks').isoWeekday(frequencyValue)
    }
  } else {
    const currentDay = moment().date()
    if (currentDay <= frequencyValue) { 
      d.date(frequencyValue)
    } else {
      d.add(1, 'months').date(frequencyValue)
    }
  }

  return d
}

const CATEGORIES = [
  { name: 'Flights', type: 'flights' },
  { name: 'Experiences', type: 'experiences' },
  { name: 'Stays', type: 'stays' },
  { name: 'Cars', type: 'cars' },
  { name: 'Cruises', type: 'cruises' },
]

export const getTripBudget = ({
  itineraries = [],
  trip = {},
}) => {
  let itineraryItems = {
    flights: [],
    experiences: [],
    stays: [],
    cars: [],
    cruises: [],
  }

  itineraries.forEach(o => {
    if (o.booking_data?.travel_type === 'AIR' || o.travel_type === 'Air') {
      itineraryItems.flights.push({
        label: o.booking_data?.segments.map(o1 => `${o1?.departure_airport?.iata_code} to ${o1?.arrival_airport?.iata_code}`)?.join('<br>'),
        // label: `${o.booking_data?.segments?.[o.booking_data?.segments?.length - 1]?.departure_airport?.iata_code} to ${o.booking_data?.segments?.[o.booking_data?.segments?.length - 1]?.arrival_airport?.iata_code}`,
        // label: `${o.booking_data?.start_airport.iata_code} to ${o.booking_data?.end_airport.iata_code}`,
        // sublabel: ``,
        cost: o.total,
      })
    } else if (o.booking_data?.travel_type === 'HOTEL' || o.travel_type === 'Hotel') {
      itineraryItems.stays.push({
        label: `${o.booking_data?.segments?.[0]?.hotel_location?.name || ''}`,
        // sublabel: ``,
        cost: o.total,
      })
    } else if (o.booking_data?.travel_type === 'EXPERIENCE' || o.travel_type === 'Experience') {
      itineraryItems.experiences.push({
        label: `${o.booking_data?.event_name || ''}`,
        // sublabel: ``,
        cost: o.total,
      })
    } else if (o.booking_data?.travel_type === 'CAR' || o.travel_type === 'Car') {
      itineraryItems.cars.push({
        // label: `${o.booking_data?.start_airport.iata_code} to ${o.booking_data?.end_airport.iata_code}`,
        label: 'Rental car',
        // sublabel: ``,
        cost: o.total,
      })
    } else if (o.booking_data?.travel_type === 'CRUISE' || o.travel_type === 'Cruise') {
      itineraryItems.cruises.push({
        label: `${o.booking_data?.vendor_name}`,
        // sublabel: ``,
        cost: o.total,
      })
    }
  })

  const filteredCategories = CATEGORIES.filter(o => +trip[`${o.type}_budgeted`] || +trip[`${o.type}_actual`] || itineraryItems[o.type].length)
  const hasCategories = !!filteredCategories.length
  const flightsActual = sumBy(itineraryItems.flights, o => o.cost)
  const experiencesActual = sumBy(itineraryItems.experiences, o => o.cost)
  const staysActual = sumBy(itineraryItems.stays, o => o.cost)
  const carsActual = sumBy(itineraryItems.cars, o => o.cost)
  const cruisesActual = sumBy(itineraryItems.cruises, o => o.cost)
  const totalActual = flightsActual + experiencesActual + staysActual + carsActual + cruisesActual

  return {
    itineraryItems,
    filteredCategories,
    hasCategories,
    flightsActual,
    experiencesActual,
    staysActual,
    carsActual,
    cruisesActual,
    totalActual,
  }
}

export const formatNumber = (x, fixedDecimals) => {
  let numberToFormat = x || 0
  if (fixedDecimals) {
    numberToFormat = numberToFormat?.toFixed?.(2)
  }
  return numberToFormat?.toString?.().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '0'
}


export const openBackgroundTab = url => {
  const newTab = window.open(url)
  // const newTab = window.open(url,'','width=600,height=600')
  // newTab.blur()
  // window.focus()
}

export const getLowestHotelPlannerAmount = hotel => {
  let lowest = null
  let currencyPrefix = '$'
  hotel.availabilities?.forEach(availability => {
    currencyPrefix = availability.currencyPrefix
    availability.roomRates?.forEach(rate => {
      lowest = lowest === null ? rate.averageBeforeTax : Math.min(lowest, rate.averageBeforeTax)
    })
  })
  return `${currencyPrefix}${lowest?.toFixed(2)}`
}

export const getLowestTravelLeisureAmount = stay => {
  let lowest = null
  let currencyPrefix = '$'
  let availability = null
  stay.accommodationItem?.forEach(o => {
    o.availabilityInfo?.forEach(info => {
      if (lowest === null) {
        lowest = info.unitCost.value
        currencyPrefix = info.unitCost.currency
        availability = info
      } else {
        lowest = Math.min(lowest, info.unitCost.value)
        if (lowest === info.unitCost.value) {
          currencyPrefix = info.unitCost.currency
          availability = info
        }
      }
    })
  })
  const returnPrefix = currencyPrefix === 'USD' ? '$' : currencyPrefix
  return {
    lowest: {
      prefix: returnPrefix,
      formatted: `${returnPrefix}${+lowest}`,
      amount: lowest,
      nightlyAverage: lowest / moment(availability.checkOutDate).diff(moment(availability.checkInDate), 'days'),
    },
    availability,
  }
}

export const getTravelLeisureAvailabilitiesDateRange = stay => {
  let startDate = null
  let endDate = null
  stay.accommodationItem?.forEach(o => {
    o.availabilityInfo?.forEach(info => {
      if (startDate === null) {
        startDate = moment(info.checkInDate)
        endDate = moment(info.checkOutDate)
      } else {
        startDate = moment(info.checkInDate).isBefore(startDate) ? moment(info.checkInDate) : startDate
        endDate = moment(info.checkOutDate).isAfter(endDate) ? moment(info.checkOutDate) : endDate
      }
    })
  })
  return {
    startDate,
    endDate,
  }
}
  

export const distributeTravelers = (totalTravelers, totalChildren) => {
  const rooms = []
  while (totalTravelers > 0 || totalChildren > 0) {
    const room = { number_adults: 0, number_children: 0, ages: {} }
    
    let roomCapacity = 5 // Max room capacity
    
    // Fill in adults
    if (totalTravelers > 0) {
      const adultsInRoom = Math.min(totalTravelers, roomCapacity)
      room.number_adults = adultsInRoom
      totalTravelers -= adultsInRoom
      roomCapacity -= adultsInRoom
    }

    // Fill in children if room capacity still remains
    if (totalChildren > 0 && roomCapacity > 0) {
      const childrenInRoom = Math.min(totalChildren, roomCapacity)
      room.number_children = childrenInRoom
      totalChildren -= childrenInRoom
    }

    rooms.push(room)
  }

  return rooms
}

export const checkString = val => val?.length ? val : undefined

export const stripHtml = htmlString => htmlString?.replace?.(/<\/?[^>]+(>|$)/g, '')

export const convertTo12Hour = (time = '') => {
  if (!/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time)) return time
  const [hour, minute] = time.split(':')
  const newHour = hour % 12 || 12
  const suffix = hour >= 12 ? 'PM' : 'AM'
  return `${newHour}:${minute} ${suffix}`
}


export const convertCurrencyFormat = (moneyString = '') => {
  const matched = moneyString.match(/US\$ ([\d,]+\.?\d{0,2})/)
  if (matched) {
    const amount = matched[1].replace(/,/g, '')
    const formattedAmount = parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    return `$${formattedAmount} USD`
  }
  return moneyString
}

export const renderBoldText = (text, query) => {
  try {
    const matchIndex = text.toLowerCase().indexOf(query.toLowerCase())
    if (matchIndex === -1) return text
  
    const preText = text.slice(0, matchIndex)
    const matchedText = text.slice(matchIndex, matchIndex + query.length)
    const postText = text.slice(matchIndex + query.length)
  
    return (
      <>
        {preText}
        <b>{matchedText}</b>
        {postText}
      </>
    )
  } catch (e) {
    return 'N/A'
  }
}

export const sanitizeString = input => {
  const cleanHtml = input?.replace?.(/<[^>]*(>|$)|[^\S ]+/g, '')
  const cleanScript = cleanHtml?.replace?.(/(on\w+)=/g, '')

  return cleanScript
}

export const renderLineBreaks = text => text?.replaceAll?.(/\n/g, '<br>')

export const toTitleCase = str => {
  if (!str) return ''
  const lowercaseStr = str.toLowerCase()
  return lowercaseStr.replace(/\b\w/g, match => match.toUpperCase())
}